<div *ngIf="init">
  <div class="d-flex small-upper-space">
    <div>
      <div>
        <span class="strong"> {{ getTitle() }} </span>

        <span *ngIf="multipleProducts" class="product-number">
          #{{ index + 1 }}
        </span>
      </div>

      <div
        *ngIf="!client || subproject.type !== 'Repo'"
        class="small-upper-space"
      >
        <span>{{ getTemporary(windowsticker.temporaryMaterial) }}</span>

        <span *ngIf="windowsticker.foil">
          - {{ windowsticker.foil.name }}
        </span>

        <span *ngIf="windowsticker.laminate">
          - {{ windowsticker.laminate.name }}
        </span>
      </div>

      <div *ngIf="!client || subproject.type !== 'Repo'">
        <div
          *ngIf="
            windowsticker.type === 'WindowSticker' &&
            windowsticker.standardStickerParts != null
          "
        >
          <div *ngIf="windowsticker.standardStickerParts.length === 1">
            Sticker:
            {{ getWindowStickerSize(windowsticker.standardStickerParts[0]) }}
          </div>

          <ng-container *ngIf="windowsticker.standardStickerParts.length > 1">
            <div
              *ngFor="
                let standardStickerPart of windowsticker.standardStickerParts;
                let i = index
              "
            >
              <span class="font-weight-bold">Sticker #{{ i + 1 }}:</span>
              {{ getWindowStickerSize(standardStickerPart) }}
            </div>
          </ng-container>
        </div>

        <div *ngIf="windowsticker.type === 'CustomWindowSticker'">
          <div
            *ngFor="
              let stickerpart of customWindowSticker.stickerParts;
              let i = index
            "
          >
            <span>
              <span
                *ngIf="customWindowSticker.stickerParts.length > 1"
                class="font-weight-bold"
              >
                Sticker #{{ i + 1 }}:
              </span>

              <span class="font-weight-bold"> Raam:</span>
              {{ stickerpart.windowHeight ? stickerpart.windowHeight : '0' }} cm
              h x
              {{ stickerpart.windowWidth ? stickerpart.windowWidth : '0' }} cm b
            </span>

            <span>
              -
              <span class="font-weight-bold">Sticker:</span>
              {{ stickerpart.stickerHeight ? stickerpart.stickerHeight : '0' }}
              cm h x
              {{ stickerpart.stickerWidth ? stickerpart.stickerWidth : '0' }} cm
              b
            </span>

            <div
              class="preserve-line-break"
              *ngIf="stickerpart.description?.length > 0"
            >
              <span>
                Opmerking sticker #{{ i + 1 }}: {{ stickerpart.description }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="windowsticker.productAssets != null"
      class="flexer large-left-space"
    >
      <div class="d-flex images">
        <div *ngFor="let item of windowsticker.productAssets | archivefilter">
          <div
            *ngIf="item?.formSection === 'execution'"
            class="loadedImg align-middle"
            matTooltip="{{ item?.asset?.name }}"
          >
            <div class="d-flex box click-link max-summary-width">
              <a
                download="{{ item.asset.name }}"
                href="/api/assets/{{ item.asset.uuid }}"
                style="margin-right: 7px"
                class="d-flex box"
              >
                <div class="filename">{{ shortenName(item?.asset?.name) }}</div>

                <a>
                  <mat-icon aria-hidden="false" aria-label="remove">
                    cloud_download
                  </mat-icon>
                </a>
              </a>
            </div>

            <a
              class="click-link"
              href="/api/assets/{{ item.asset.uuid }}"
              *ngIf="isImage(item.asset)"
              data-lightbox="product"
            >
              <img
                *ngIf="isImage(item.asset)"
                class="max-summary-width max-summary-height"
                src="/api/assets/{{ item.asset.uuid }}"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
